import React from 'react'
import {
  faDownload,
  faHome,
  faUsers,
  faUserSlash,
  faAddressCard,
  faToggleOn,
  faRandom,
  faHistory,
  faTable
} from '@fortawesome/free-solid-svg-icons'
import SidebarLink from './sidebar-link'
import { useSidebar } from '../sidebar-context'

function Sidebar() {
  const { isCollapsed, mobileOpen, closeMobile, isMobile } = useSidebar()

  const navClasses = [
    'sidebar',
    'bg-light',
    isCollapsed ? 'sidebar-collapsed' : '',
    isMobile ? 'sidebar-mobile' : '',
    isMobile && mobileOpen ? 'sidebar-mobile-open' : ''
  ]
    .filter(Boolean)
    .join(' ')

  const handleNavigate = isMobile ? closeMobile : undefined

  return (
    <>
      {isMobile && mobileOpen && (
        <div
          className="sidebar-backdrop"
          role="presentation"
          onClick={closeMobile}
        />
      )}
      <nav className={navClasses} aria-label="Main navigation">
        <div className="sidebar-sticky">
          <ul className="nav flex-column mt-2">
            <SidebarLink
              path={'duties'}
              url="duties"
              title="Home"
              icon={faHome}
              onNavigate={handleNavigate}
            />
            <SidebarLink
              path={'conflicts'}
              url="conflicts"
              title="Conflicts"
              icon={faUserSlash}
              onNavigate={handleNavigate}
            />
            <SidebarLink
              path={'roles'}
              url="roles"
              title="Roles"
              icon={faAddressCard}
              onNavigate={handleNavigate}
            />
            <SidebarLink
              path={'users'}
              url="users"
              title="Users"
              icon={faUsers}
              onNavigate={handleNavigate}
            />
            <SidebarLink
              path={'permissions'}
              url="permissions"
              title="Permissions"
              icon={faToggleOn}
              onNavigate={handleNavigate}
            />
            <SidebarLink
              path={'data-access'}
              url="data-access"
              title="Data Access"
              icon={faTable}
              onNavigate={handleNavigate}
            />
            <SidebarLink
              path={'processes'}
              url={'processes'}
              title={'Workflow Processes'}
              icon={faRandom}
              onNavigate={handleNavigate}
            />
            <SidebarLink
              path={'audit-logs'}
              url="audit-logs"
              title="Audit Logs"
              icon={faHistory}
              onNavigate={handleNavigate}
            />
            <SidebarLink
              path={'access-management-exports'}
              url={'access-management-exports'}
              title={'Exports'}
              icon={faDownload}
              onNavigate={handleNavigate}
            />
          </ul>
        </div>
      </nav>
    </>
  )
}

export default Sidebar
